import { OrderItem } from "./order-item";

export class Order_Dto {
  public id: number;
  public tenantId: number;
  public firstName: string;
  public lastName: string;
  public streetAddress: string;
  public streetAddress2: string;
  public city: string;
  public state: string;
  public zipCode: string;
  public phoneNumber: string;
  public isMobile: boolean;
  public emailAddress: string;
  public validationMethod: string;

  public items: Order_Item_Dto[];

}

export class Order_Item_Dto {
  public productId: number;
  public size: string;
  public quantity: number;
  public orderId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/order-dto.ts